import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './daily.css'


function Empty() {
    return (
        <div className="App">
            <div className="daily">
                没有需要上报的内容
            </div>
        </div>
    );
}

export default Empty;
